<template>
    <div v-if="impactToken" class="share">
        <!-- eslint-disable-next-line vue/component-name-in-template-casing -->
        <impact-embed widget="p/48899/w/referrerWidget"><div>Loading...</div></impact-embed>
    </div>
    <EmptyState
        v-else-if="!isLoading && !impactToken"
        title="Our referral program is temporarily unavailable."
        message="Please reload the page or check back later. If the problem persists please contact our support team."
    >
        <template #imageRow>
            <div />
        </template>
    </EmptyState>
</template>

<script setup lang="ts">
import UIKit from '@pocketprep/ui-kit'
import { userModule } from '@/store/user/module'
import { onMounted, ref } from 'vue'

const {
    EmptyState,
} = UIKit

const isLoading = ref(true)
const impactToken = ref('')

onMounted(async () => {
    await userModule.actions.fetchUserData()
    await userModule.actions.fetchImpactJWT()
    if (window.impactToken) {
        impactToken.value = window.impactToken
    }
    isLoading.value = false
})
</script>

<style lang="scss" scoped>
.share {
    font-size: 16px;
}
</style>
